module.exports = __webpack_public_path__ + "img/116.10.786ee9af.png";